import constants from 'app/constants'
import { LOCAL_STORAGE } from 'app/localStorageManager'
import { ERROR_CODE } from 'app/util/errorCodes'
import { API_ERROR_RESPONSE_MESSAGE, API_RESPONSE } from './constants'
import getSignature from './getSignature'

/**
 * Create an account with a passport - the user is a
 * passport holder
 *
 * @param {object} formData - the form data
 * @param {object} signer - the signer info
 * @returns {object?} the result or null if failed
 */
const createWithSignature = async (formData, signer) => {
  const signature = await getSignature(formData.wallet, signer)

  if (!signature) {
    // Fail
    return null
  }

  const response = await fetch(
    `${constants.API_V2_URL}/frontend/customers/passport`,
    {
      method: 'POST',
      body: JSON.stringify({
        ...formData,
        network: constants.NETWORK
      }),
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json',
        'X-Signature': signature
      }
    }
  )
  const data = await response.json()

  if (data?.token) {
    // Has token, add it to local storage
    localStorage.setItem(LOCAL_STORAGE.userTokenCache, data.token)
  }

  return data
}

/**
 * Create an account with a passport (user has passport)
 *
 * @param {object} formData - the form data
 * @param {Function} getSigner - the signer method
 * @returns {object} the result
 */
const submitSignUpWithPassport = async (formData, getSigner) => {
  let res

  try {
    const signer = await getSigner()

    res = await createWithSignature(formData, signer)
  } catch (e) {
    console.error(e)
  }

  if (!res) {
    return {
      success: false,
      message: ERROR_CODE.UNKNOWN
    }
  }

  if (res?.message === API_RESPONSE.SIGNED_UP) {
    return {
      success: true,
      ...res
    }
  }

  return {
    success: false,
    message: API_ERROR_RESPONSE_MESSAGE[res?.message] || ERROR_CODE.UNKNOWN
  }
}

// Export
export default submitSignUpWithPassport
